/**
 * Naming for the in-progress Word document when it is uploaded as a source.
 *
 * Two section types are generated from the document being written rather than
 * from the project's own sources, so the add-in uploads a snapshot of it first.
 * Both used to land as "document.docx", which made the two indistinguishable in
 * the documents list once uploaded.
 *
 * Returns null for sections that need no upload, so callers can use it as both
 * the gate and the name.
 */
export const currentDocumentUploadName = (sectionDisplayName: string): string | null => {
  const name = (sectionDisplayName || "").toLowerCase();
  if (name.includes("executive summary")) return "exec-document.docx";
  if (name.includes("abbreviation")) return "abbr-document.docx";
  return null;
};
